/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SavedStateVariableEnum } from "./SavedStateVariableEnum";
import {
  SavedStateVariableEnumFromJSON,
  SavedStateVariableEnumFromJSONTyped,
  SavedStateVariableEnumToJSON,
  SavedStateVariableEnumToJSONTyped,
} from "./SavedStateVariableEnum";

/**
 *
 * @export
 * @interface Threshold
 */
export interface Threshold {
  /**
   *
   */
  variable: SavedStateVariableEnum;
  /**
   *
   */
  value: number;
}

/**
 * Check if a given object implements the Threshold interface.
 */
export function instanceOfThreshold(value: object): value is Threshold {
  if (!("variable" in value) || value["variable"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function ThresholdFromJSON(json: any): Threshold {
  return ThresholdFromJSONTyped(json, false);
}

export function ThresholdFromJSONTyped(json: any, ignoreDiscriminator: boolean): Threshold {
  if (json == null) {
    return json;
  }
  return {
    variable: SavedStateVariableEnumFromJSON(json["variable"]),
    value: json["value"],
  };
}

export function ThresholdToJSON(json: any): Threshold {
  return ThresholdToJSONTyped(json, false);
}

export function ThresholdToJSONTyped(
  value?: Threshold | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    variable: SavedStateVariableEnumToJSON(value["variable"]),
    value: value["value"],
  };
}
